var map = {
	"./barstool.svg": [
		989,
		43
	],
	"./bathroom_cabinet.svg": [
		990,
		44
	],
	"./bbq.svg": [
		991,
		45
	],
	"./bed_side_table.svg": [
		992,
		46
	],
	"./cabinet.svg": [
		993,
		47
	],
	"./chest_of_drawers.svg": [
		994,
		48
	],
	"./childerens_bicycle.svg": [
		995,
		49
	],
	"./clothes_rack.svg": [
		996,
		50
	],
	"./coat rack.svg": [
		997,
		51
	],
	"./complete.svg": [
		518
	],
	"./cradle.svg": [
		998,
		52
	],
	"./crib.svg": [
		999,
		53
	],
	"./crockery_cabinet.svg": [
		1000,
		54
	],
	"./default.svg": [
		404
	],
	"./desk.svg": [
		1001,
		55
	],
	"./dishwasher.svg": [
		1002,
		56
	],
	"./display_cabinet.svg": [
		1003,
		57
	],
	"./drawer_unit.svg": [
		1004,
		58
	],
	"./dressboy.svg": [
		1005,
		59
	],
	"./dressing_table.svg": [
		1006,
		60
	],
	"./elevator.svg": [
		1007,
		61
	],
	"./exercise_bike.svg": [
		1008,
		62
	],
	"./garden_armchair.svg": [
		1009,
		63
	],
	"./garden_cushions.svg": [
		1010,
		64
	],
	"./garden_seat.svg": [
		1011,
		65
	],
	"./garden_table.svg": [
		1012,
		66
	],
	"./garden_tools.svg": [
		1013,
		67
	],
	"./go_kart.svg": [
		1014,
		68
	],
	"./ironing_board.svg": [
		1015,
		69
	],
	"./kitchen_trolley.svg": [
		1016,
		70
	],
	"./ladder.svg": [
		1017,
		71
	],
	"./laundry_basket.svg": [
		1018,
		72
	],
	"./lawnmower.svg": [
		1019,
		73
	],
	"./lounge_table.svg": [
		1020,
		74
	],
	"./lounger.svg": [
		1021,
		75
	],
	"./mattress.svg": [
		1022,
		76
	],
	"./mirror.svg": [
		1023,
		77
	],
	"./paddling_pool.svg": [
		1024,
		78
	],
	"./paperclip.svg": [
		986,
		79
	],
	"./paraph.svg": [
		1025,
		80
	],
	"./patio_heater.svg": [
		1026,
		81
	],
	"./porch_swing.svg": [
		1027,
		82
	],
	"./pram.svg": [
		1028,
		83
	],
	"./roofbox.svg": [
		1029,
		84
	],
	"./sandbar.svg": [
		1030,
		85
	],
	"./secretary.svg": [
		1031,
		86
	],
	"./shoe_closet.svg": [
		1032,
		87
	],
	"./side_table.svg": [
		1033,
		88
	],
	"./sideboard.svg": [
		1034,
		89
	],
	"./sink_cabinet.svg": [
		1035,
		90
	],
	"./slide.svg": [
		1036,
		91
	],
	"./statisticsBackground.svg": [
		985,
		92
	],
	"./statue.svg": [
		1037,
		93
	],
	"./swing_set.svg": [
		1038,
		94
	],
	"./trampoline.svg": [
		1039,
		95
	],
	"./tv_cabinet.svg": [
		1040,
		96
	],
	"./unchecked.svg": [
		519
	],
	"./wardrobe.svg": [
		1041,
		97
	],
	"./waterbed.svg": [
		1042,
		98
	],
	"./wheelbarrow.svg": [
		1043,
		99
	],
	"./workbench.svg": [
		1044,
		100
	],
	"./workmate.svg": [
		1045,
		101
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 930;
module.exports = webpackAsyncContext;